import { useEffect, useRef } from "react";
import { handleMessages } from "../firebaseMessageHandler";
import { useAppSelector } from "../store/hooks";

export const useNotifications = () => {
  const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
  let initiatedRef = useRef(false);
  useEffect(() => {
    if (!isLoggedIn) return;
    if (initiatedRef.current) return;
    initiatedRef.current = true;
    handleMessages();
  }, [isLoggedIn]);
};
